import React from "react";
import SharePriceTabContent from "./SharePriceTabContent";
import HistoryTabContent from "./HistoryTabContent";
import { useTemplateSetting } from "../hooks/useCompanySettings";
// import useRenderTextBasedOnTab from "../hooks/useRenderTextBasedOnTab";
import { TOOL_TEMPLATE, TAB } from "../constant/common";
import {i18n} from "@euroland/libs";
import { classNames } from "../utils";
import { useInstrument } from "../hooks/useInstruments";
import { renderTextBasedOnTemplate } from "../store/utils";
import MultipleTicker from "./MultipleTicker";
import { useMainContext } from "../contexts/MainContext";
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@euroland/react-tablist'
import { useMainAppHeightAdjustment } from "../hooks/useMainAppHeightAdjustment";

const MainContent = () => {
  const { tab, tabSet } = useMainContext();
  useMainAppHeightAdjustment([tab]);
  const template = useTemplateSetting();
  const [{ isIpo, loadedInstruments }] = useInstrument();
  const { currentTab, isChangeTab } = tab;

  const isQuadrata = template === TOOL_TEMPLATE.quadrata;
  const isVictor = template === TOOL_TEMPLATE.victor;

  const handleChangeTab = (selectedTab, tabName) => {
    tabSet({
      currentTab: selectedTab,
      isChangeTab: !isChangeTab,
      tabName: tabName,
    });
  };

  // if (!loadedInstruments) return null;
  return (
    <>
      {template === TOOL_TEMPLATE.quadrata && <MultipleTicker />}
      {!loadedInstruments ? null : (
        <Tabs activeTab={currentTab} onChangeTab={handleChangeTab}>
          <TabList
            ariaLabel={i18n.translate("sharePriceTabs")}
            className={classNames("switch--control", {
              quadrata: isQuadrata,
              victor: isVictor,
            })}
          >
            <div className="switch--control__container">
              <div className="switch--control__wrap-button one">
                <Tab
                  value={TAB.history}
                  className="button"
                  activeClassName="button--primary"
                >
                  {renderTextBasedOnTemplate(
                    i18n.translate("historicalTabQuadrata"),
                    i18n.translate("historicalTabVictor")
                  )}
                </Tab>
              </div>
              <div className="switch--control__wrap-button">
                <Tab
                  value={TAB.sharePrice}
                  className="button"
                  activeClassName="button--primary"
                >
                  {renderTextBasedOnTemplate(
                    i18n.translate("sharePriceTabQuadrata"),
                    i18n.translate("sharePriceTabVictor")
                  )}
                </Tab>
              </div>
            </div>
          </TabList>

          {isIpo ? (
            <article className="ipo">
              <h1 className="ipo__title">{i18n.translate("ipoTitle")}</h1>
              <p className="ipo__text">{i18n.translate("ipoText")}</p>
            </article>
          ) : (
            <TabPanels>
              <TabPanel forTab={TAB.sharePrice}>
                <SharePriceTabContent currentTab={currentTab} isChangeTab={isChangeTab} />
              </TabPanel>
              <TabPanel forTab={TAB.history}>
                <HistoryTabContent currentTab={currentTab} isChangeTab={isChangeTab} />
              </TabPanel>
            </TabPanels>
          )}
        </Tabs>
      )}
    </>
  );
};

export default MainContent;
